import { useGlobalStateContext } from "@/context/GlobalContext";

/**
 * Custom hook to get the isVendor state from global context
 * This hook provides a convenient way to access the isVendor boolean
 * that is automatically computed based on userDetails.type === "VENDOR"
 * 
 * @returns {boolean} isVendor - true if user type is "VENDOR", false otherwise
 */
export const useIsVendor = (): boolean => {
  const { isVendor } = useGlobalStateContext();
  return isVendor;
};
